var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.administrations)?_c('OwnersAssociations',{attrs:{"has_multiples_owners_associations":_vm.has_multiples_owners_associations,"administrations":_vm.administrations,"getAvatar":_vm.getAvatar,"get2xAvatar":_vm.get2xAvatar}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }